import * as React from "react"
import PaymentFields from "payment-fields"
import theme from "../../theme"
import InputWrapper from "BookingSystem/components/InputWrapper"
import InputLabel from "BookingSystem/components/InputLabel"
import styled from "styled-components"
import { Flex } from "rebass"

export class PaymentInfo extends React.Component<{
  onTokenize: (tokenize: any) => void
}> {
  render() {
    const StyledInputWrapper = styled(InputWrapper)`
      width: 100%;
      height: 42px;
      background: ${theme.colors.white};
      margin-bottom: 4%;
      margin-top: 4%;
    `

    const StyledInputLabel = styled(InputLabel)`
      color: black;
      background-color: white;
    `
    return (
      <PaymentFields
        vendor="Square"
        authorization="sq0idp-BW4eAdshbdb-5QJaDqemZA"
        onReady={(params: any) => {
          const { onTokenize } = this.props
          onTokenize && onTokenize(params.tokenize)
        }}
        styles={{
          base: {
            "font-size": "24px",
            "font-family": "helvetica, tahoma, calibri, sans-serif",
            padding: "6px",
            color: theme.colors.black,
            "background-color": theme.colors.inputBackground
          },
          focus: { color: "#000000" },
          valid: { color: "#00bf00" },
          invalid: { color: "#a00000" }
        }}
      >
        <Flex flexDirection={"column"}>
          <StyledInputWrapper>
            <StyledInputLabel>Card Number</StyledInputLabel>
            <PaymentFields.Field
              type="cardNumber"
              placeholder="•••• •••• •••• ••••"
            />
          </StyledInputWrapper>
          <StyledInputWrapper>
            <StyledInputLabel>Expirtion Date</StyledInputLabel>
            <PaymentFields.Field type="expirationDate" placeholder="MM/YY" />
          </StyledInputWrapper>
          <StyledInputWrapper>
            <StyledInputLabel>CVV</StyledInputLabel>
            <PaymentFields.Field type="cvv" />
          </StyledInputWrapper>
          <StyledInputWrapper>
            <StyledInputLabel>Zip Code</StyledInputLabel>
            <PaymentFields.Field type="postalCode" />
          </StyledInputWrapper>
        </Flex>
      </PaymentFields>
    )
  }
}
